<script>
import Repositories from '@/repositories/no-authorization';
export default {
  data() {
    return {
      currentLang: null,
      lan: this.$i18n.locale,
      text: null,
      flag: null,
      keyGenRepository: null,
      organisationName: '',
      languages: [
        {
          flag: require('@/assets/images/flags/us.jpg'),
          language: 'en',
          title: 'English',
        },
        {
          flag: require('@/assets/images/flags/french.jpg'),
          language: 'fr',
          title: 'Français',
        },
      ],
    };
  },
  mounted() {
    this.currentLang = this.languages.find(
      (x) => x.language === this.$i18n.locale
    );
    this.text = this.currentLang.title;
    this.flag = this.currentLang.flag;
  },
  created() {
    this.keyGenRepository = Repositories.get(
      'keygen',
      this.$route.params.orgcode
    );
    this.loadData();
  },
  methods: {
    loadData() {
      this.keyGenRepository.actions
        .getOrganisationName(this.$route.params.orgcode)
        .then(({ data }) => {
          this.organisationName = data;
        })
        .catch(() => {
          // eslint-disable-next-line
          console.error(
            `Error loading the organisation name from code: ${this.$route.params.orgcode}`
          );
        });
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      this.$i18n.locale = locale;
    },
  },
};
</script>

<template>
  <header>
    <b-container fluid>
      <b-row style="height: 58px">
        <b-col cols="6" class="vertical-align">
          <h2 class="mb-0">{{ organisationName }}</h2>
        </b-col>
        <b-col></b-col>
        <b-col cols="2" class="text-right">
          <b-dropdown variant="white" right toggle-class="header-item">
            <template v-slot:button-content>
              {{ text }}
            </template>
            <b-dropdown-item
              class="notify-item"
              v-for="(entry, i) in languages"
              :key="`Lang${i}`"
              :value="entry"
              @click="setLanguage(entry.language, entry.title, entry.flag)"
              :class="{ active: lan === entry.language }"
            >
              <span class="align-middle">{{ entry.title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<style scoped>
header {
  background-color: white;
}

.vertical-align {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>